import { createLocalIcon } from './createLocalIcon';

export const IconAccessPoint = createLocalIcon(
    'IconAccessPoint',
    <>
        <path d="M12 12l0 .01" />
        <path d="M14.828 9.172a4 4 0 0 1 0 5.656" />
        <path d="M17.657 6.343a8 8 0 0 1 0 11.314" />
        <path d="M9.168 14.828a4 4 0 0 1 0 -5.656" />
        <path d="M6.337 17.657a8 8 0 0 1 0 -11.314" />
    </>
);

export const IconApi = createLocalIcon(
    'IconApi',
    <>
        <path d="M4 13h5" />
        <path d="M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3" />
        <path d="M20 8v8" />
        <path d="M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5" />
    </>
);

export const IconArrowRight = createLocalIcon(
    'IconArrowRight',
    <>
        <path d="M5 12l14 0" />
        <path d="M13 18l6 -6" />
        <path d="M13 6l6 6" />
    </>
);

export const IconBook = createLocalIcon(
    'IconBook',
    <>
        <path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
        <path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
        <path d="M3 6l0 13" />
        <path d="M12 6l0 13" />
        <path d="M21 6l0 13" />
    </>
);

export const IconCertificate = createLocalIcon(
    'IconCertificate',
    <>
        <path d="M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
        <path d="M13 17.5v4.5l2 -1.5l2 1.5v-4.5" />
        <path d="M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73" />
        <path d="M6 9l12 0" />
        <path d="M6 12l3 0" />
        <path d="M6 15l2 0" />
    </>
);

export const IconDashboard = createLocalIcon(
    'IconDashboard',
    <>
        <path d="M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
        <path d="M13.45 11.55l2.05 -2.05" />
        <path d="M6.4 20a9 9 0 1 1 11.2 0z" />
    </>
);

export const IconFileCertificate = createLocalIcon(
    'IconFileCertificate',
    <>
        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
        <path d="M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5" />
        <path d="M6 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
        <path d="M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5" />
    </>
);

export const IconFileTypePdf = createLocalIcon(
    'IconFileTypePdf',
    <>
        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
        <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" />
        <path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" />
        <path d="M17 18h2" />
        <path d="M20 15h-3v6" />
        <path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z" />
    </>
);

export const IconForms = createLocalIcon(
    'IconForms',
    <>
        <path d="M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3" />
        <path d="M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3" />
        <path d="M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7" />
        <path d="M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1" />
        <path d="M17 12h.01" />
        <path d="M13 12h.01" />
    </>
);

export const IconMailSearch = createLocalIcon(
    'IconMailSearch',
    <>
        <path d="M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5" />
        <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
        <path d="M20.2 20.2l1.8 1.8" />
        <path d="M3 7l9 6l9 -6" />
    </>
);

export const IconMinusVertical = createLocalIcon(
    'IconMinusVertical',
    <>
        <path d="M12 5v14" />
    </>
);

export const IconPackageImport = createLocalIcon(
    'IconPackageImport',
    <>
        <path d="M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5" />
        <path d="M12 12l8 -4.5" />
        <path d="M12 12v9" />
        <path d="M12 12l-8 -4.5" />
        <path d="M22 18h-7" />
        <path d="M18 15l-3 3l3 3" />
    </>
);

export const IconPencilCog = createLocalIcon(
    'IconPencilCog',
    <>
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
        <path d="M13.5 6.5l4 4" />
        <path d="M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
        <path d="M19.001 15.5v1.5" />
        <path d="M19.001 21v1.5" />
        <path d="M22.032 17.25l-1.299 .75" />
        <path d="M17.27 20l-1.3 .75" />
        <path d="M15.97 17.25l1.3 .75" />
        <path d="M20.733 20l1.3 .75" />
    </>
);

export const IconPencilMinus = createLocalIcon(
    'IconPencilMinus',
    <>
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
        <path d="M13.5 6.5l4 4" />
        <path d="M16 19h6" />
    </>
);

export const IconPencilShare = createLocalIcon(
    'IconPencilShare',
    <>
        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
        <path d="M13.5 6.5l4 4" />
        <path d="M16 22l5 -5" />
        <path d="M21 21.5v-4.5h-4.5" />
    </>
);

export const IconPhotoSensor2 = createLocalIcon(
    'IconPhotoSensor2',
    <>
        <path d="M17 5h2a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-2" />
        <path d="M7 19h-2a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2" />
        <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
    </>
);

export const IconRubberStamp = createLocalIcon(
    'IconRubberStamp',
    <>
        <path d="M21 17.85h-18c0 -4.05 1.421 -4.05 3.79 -4.05c5.21 0 1.21 -4.59 1.21 -6.8a4 4 0 1 1 8 0c0 2.21 -4 6.8 1.21 6.8c2.369 0 3.79 0 3.79 4.05" />
        <path d="M5 21h14" />
    </>
);

export const IconReplace = createLocalIcon(
    'IconReplace',
    <>
        <path d="M3 3m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M15 15m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3" />
        <path d="M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3" />
    </>
);

export const IconSignature = createLocalIcon(
    'IconSignature',
    <>
        <path d="M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2" />
    </>
);

export const IconTallymark1 = createLocalIcon(
    'IconTallymark1',
    <>
        <path d="M12 5l0 14" />
    </>
);

export const IconTemplate = createLocalIcon(
    'IconTemplate',
    <>
        <path d="M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z" />
        <path d="M4 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
        <path d="M14 12l6 0" />
        <path d="M14 16l6 0" />
        <path d="M14 20l6 0" />
    </>
);

export const IconTextRecognition = createLocalIcon(
    'IconTextRecognition',
    <>
        <path d="M4 8v-2a2 2 0 0 1 2 -2h2" />
        <path d="M4 16v2a2 2 0 0 0 2 2h2" />
        <path d="M16 4h2a2 2 0 0 1 2 2v2" />
        <path d="M16 20h2a2 2 0 0 0 2 -2v-2" />
        <path d="M12 16v-7" />
        <path d="M9 9h6" />
    </>
);

export const IconWriting = createLocalIcon(
    'IconWriting',
    <>
        <path d="M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z" />
        <path d="M16 7h4" />
        <path d="M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3" />
    </>
);
